const LowFinanceBanner = () => {
  return (
    <div className="ac-promo low-finance-promo ch-bg--ac-black ch-color--white ch-rounded--md">
      <div className="ac-promo__heading ch-align-items--end">
        <p className="ac-promo__title ch-mb--0 ch-fw--500">
          Low-rate finance available from 8.9% APR.
        </p>
        <img alt="" className="ac-promo__image" height="52" width="127" />
      </div>
    </div>
  );
};

export default LowFinanceBanner;
